<template>
    <div>
        <el-drawer :modal="false" 
            title="Prescreening Analysis Report"
            :visible.sync="showDrawer"
            class="drawer-fintscore-history"
            size="45%"
            v-loading="is_loading"
        >
            <b-container>
                <b-row>
                    <b-col cols="12">
                        <el-button class="bg-primary text-white" 
                                @click="openPurchaseReportDrawer" 
                                v-if="!current_customer.cjp_id"
                            >Prescreening Analysis
                            </el-button>
                        </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col cols="12">
                        <div class="card-table rounded-bottom">                            
                            <el-table
                                :data="tableData"
                                style="width: 100%">
                                    <el-table-column
                                        prop="credit_report_id"
                                        label="ID"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="credit_report_platform"
                                        label="Platform"
																				min-width="100"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="credit_report_request_datetime"
                                        label="Requested Date"
                                        min-width="160"
                                    >
                                        <template v-slot="{row}">
                                            {{ row.credit_report_request_datetime | dateTimeFormatString }}
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column
                                        prop="angkasa"
                                        label="Angkasa (SPGA)"
                                        min-width="150"
                                        class-name="text-center">
                                        <template v-slot="{row}">
                                            <i class="fa fa-check-circle text-success fa-lg" v-if="row.credit_report_angkasa"></i>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        v-if="!(_gHlp.checkAccess(['cr_hide_fintscore__report']))"
                                        label="Prescreening Analysis Report"
                                        min-width="170">
                                        <template v-slot="{row}">
                                            <a href="javascript:void(0)" 
                                                @click="$refs.preview_modal.preview( row.credit_report_fintscore_unsigned_url)"
                                                class="font-weight-bold"
                                                v-if="row.credit_report_fintscore_unsigned_url !== '' && row.credit_report_fintscore_unsigned_url !== null"
                                            >View</a>
                                            <span v-else>-</span>
                                        </template>
                                    </el-table-column> -->
                                    <el-table-column
                                        prop="credit_report_pdf_unsigned_url"
                                        label="CBM Report"
                                        min-width="170">
                                        <template v-slot="{row}">
                                            <a href="javascript:void(0)" 
                                                @click="$refs.preview_modal.preview( row.credit_report_pdf_unsigned_url)"
                                                class="font-weight-bold"
                                                v-if="row.credit_report_pdf_unsigned_url !== '' && row.credit_report_pdf_unsigned_url !== null"
                                            >View</a>
                                            <span v-else>-</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="credit_report_consent_unsigned_url"
                                        label="Consent Form"
                                        min-width="170">    
                                        <template v-slot="{row}">
                                            <a href="javascript:void(0)" 
                                                @click="$refs.preview_modal.preview(row.credit_report_consent_unsigned_url)"
                                                class="font-weight-bold" 
                                                v-if="row.credit_report_consent_unsigned_url !== '' && row.credit_report_consent_unsigned_url !== null"
                                            >View</a>
                                            <span v-else>-</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="credit_report_ic_front_unsigned_url"
                                        label="Front NRIC"
                                        min-width="170">    
                                        <template v-slot="{row}">
                                            <a href="javascript:void(0)" 
                                                @click="$refs.preview_modal.preview(row.credit_report_ic_front_unsigned_url)"
                                                class="font-weight-bold" 
                                                v-if="row.credit_report_ic_front_unsigned_url !== '' && row.credit_report_ic_front_unsigned_url !== null"
                                            >View</a>
                                            <span v-else>-</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="credit_report_ic_back_unsigned_url"
                                        label="Back NRIC"
                                        min-width="170">    
                                        <template v-slot="{row}">
                                            <a href="javascript:void(0)" 
                                                @click="$refs.preview_modal.preview(row.credit_report_ic_back_unsigned_url)"
                                                class="font-weight-bold" 
                                                v-if="row.credit_report_ic_back_unsigned_url !== '' && row.credit_report_ic_front_unsigned_url !== null"
                                            >View</a>
                                            <span v-else>-</span>
                                        </template>
                                    </el-table-column>
                            </el-table>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </el-drawer>
        <PreviewModal ref="preview_modal"></PreviewModal>
    </div>
</template>
<script>
    import { Drawer, Button, Table, TableColumn } from 'element-ui'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    import {axios, services, getHeader } from '@/assets/js/httpImports.js'
    import { mapState, mapActions } from 'pinia'
    import { useCustomerStore } from '@/stores/customerStore'
    import { useFintscoreStore } from '@/stores/fintscoreStore'
    import { useConfigStore } from '@/stores/configStore'
    import PreviewModal  from '@/components/Modal/PreviewModal'

    export default {
        components: {
            [Drawer.name]: Drawer,
            [Button.name]: Button,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            PreviewModal
        },
        mixins: [notifyFunctionMixin],
        data() {
            return {
                showDrawer: false,
                tableData: [],
                is_loading:false
            }
        },
        computed:{
            ...mapState(useCustomerStore, ['current_customer']),
            ...mapState(useFintscoreStore, ['fintscore_reports', 'discount_fintscore_price']),
            ...mapState(useConfigStore, ['app_code'])
        },
        created(){
            this.getCreditReportHistory()
        },
        watch:{
            fintscore_reports(newVal){
                const items = []
                this.tableData.forEach((item)=>{
                    newVal.forEach((f_item)=>{
                        if(item.credit_report_id == f_item.fin_credit_report_id){
                            items.push({
                                ...item,
                                fintscore_url: f_item.credit_report_pdf_unsigned_url
                            })
                        }
                    })
                })
                this.tableData = items
            }
        },
        methods: {
            openPurchaseReportDrawer(){
                this.showDrawer = false
                this.$emit('open-purchase-report');
            },
            openDrawer() {
                this.showDrawer = !this.showDrawer;
            },
            getCreditReportHistory(){
							this.is_loading = true
							let queryParams = _gHlp.generateQueryParams({
								paginate:100,
								page:1,
								orderBy:{
									credit_report_id:'desc'
								},
								search:{
									credit_report_cust_id:this.current_customer.customer_id,	
									credit_report_status:'completed',	
									credit_report_application_code:this.app_code,	
								}
							})

							const url = `${services.commitment}credit-reports?${queryParams}`
							axios.get(url, {headers: getHeader()})
							.then(res => {
									this.tableData = res.data.data
									this.is_loading = false
							}).catch(e => {
									this.is_loading = false
									this.errorFunction(e)
							})
            }
        }
    }
</script>